import { action, makeObservable, observable } from 'mobx';
import { makePersistable, isHydrated } from 'mobx-persist-store';

import { AiChatMessage } from 'us-web-services';
import { Storage } from '../../constants';

export class ChatStore {
  assistantMessages: AiChatMessage[] = [];

  constructor() {
    makeObservable(this, {
      assistantMessages: observable,
      addMessage: action,
      clearMessages: action,
      setMessages: action,
    });

    makePersistable(this, {
      name: Storage.US_CHAT_HISTORY,
      properties: ['assistantMessages'],
      storage: window.localStorage,
    });
  }

  get isHydrated(): boolean {
    return isHydrated(this);
  }

  addMessage(message: AiChatMessage): void {
    this.assistantMessages.push(message);
  }

  setMessages(messages: AiChatMessage[]): void {
    this.assistantMessages = messages;
  }

  clearMessages(): void {
    this.assistantMessages = [];
  }
}
